import { render, staticRenderFns } from "./ClubWallet.vue?vue&type=template&id=64ad32c3&scoped=true&"
import script from "./ClubWallet.vue?vue&type=script&lang=ts&"
export * from "./ClubWallet.vue?vue&type=script&lang=ts&"
import style0 from "./ClubWallet.vue?vue&type=style&index=0&id=64ad32c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ad32c3",
  null
  
)

export default component.exports